import { network } from 'services/network';

export const setKeyActivitiesTags = (params) => {
    return network.post('api/bo/setKeyActivitiesTags', params).then((response) => {
        return response.data;
    });
};
